"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OOO_FORWARD_TO_FULL_NAME = exports.OOO_FORWARD_TO_EMAIL = exports.OOO_FORWARD_TO = exports.OOO_END_DATE = exports.OOO_START_DATE = exports.OOO_ENABLED = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const date_fns_1 = require("date-fns");
const dayjs_1 = __importDefault(require("dayjs"));
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../constants/appConstants");
const uiConstants_1 = require("../../../constants/uiConstants");
const companyQuery_1 = require("../../../queries/companyQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const translationUtil_1 = require("../../../utils/translationUtil");
const zustandStore_1 = require("../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const headerNavigation_1 = __importDefault(require("../../organisms/header/headerNavigation"));
const useHeaderState_1 = require("../../organisms/header/simpleHeader/hooks/useHeaderState");
const downloadReportAside_1 = __importDefault(require("../manageSettlements/settlementTable/downloadReportAside"));
dayjs_1.default.extend(isBetween_1.default);
dayjs_1.default.extend(utc_1.default);
const lexico = new lexico_1.default();
exports.OOO_ENABLED = appConstants_1.userTeamProperties.outOfOffice.oooEnabled;
exports.OOO_START_DATE = appConstants_1.userTeamProperties.outOfOffice.oooStartDate;
exports.OOO_END_DATE = appConstants_1.userTeamProperties.outOfOffice.oooEndDate;
exports.OOO_FORWARD_TO = appConstants_1.userTeamProperties.outOfOffice.oooForwardTo;
exports.OOO_FORWARD_TO_EMAIL = appConstants_1.userTeamProperties.outOfOffice.oooForwardToEmail;
exports.OOO_FORWARD_TO_FULL_NAME = appConstants_1.userTeamProperties.outOfOffice.oooForwardToFullName;
const approvalTabs = [
    {
        label: 'Pending Requests',
        link: '/approvals',
        id: 'pending',
    },
    {
        label: 'Approved',
        link: '/approvals/approved',
        id: 'approved',
    },
    {
        label: 'Declined',
        link: '/approvals/declined',
        id: 'declined',
    },
    {
        label: (0, translationUtil_1.getCancelledWord)('Canceled'),
        link: '/approvals/canceled',
        id: 'canceled',
    },
];
const activityTabs = [
    {
        label: 'Pending Requests',
        link: '/activity',
        id: 'pending',
    },
    {
        label: 'Approved',
        link: '/activity/approved',
        id: 'approved',
    },
    {
        label: 'Declined',
        link: '/activity/declined',
        id: 'declined',
    },
    {
        label: (0, translationUtil_1.getCancelledWord)('Canceled'),
        link: '/activity/canceled',
        id: 'canceled',
    },
];
function getTabHeader(pathName) {
    const isActivity = pathName.startsWith('/activity');
    const tabs = isActivity ? activityTabs : approvalTabs;
    const tabHeaderMap = tabs.reduce((acc, tab) => {
        return { ...acc, [tab.link]: tab };
    }, {});
    const matchingPath = Object.keys(tabHeaderMap).find(path => path.includes(pathName));
    return matchingPath ? tabHeaderMap[matchingPath]?.id : '';
}
const isOutOutOfOffice = (outOfOfficeSettings) => {
    if (!outOfOfficeSettings || !outOfOfficeSettings[exports.OOO_START_DATE] || !outOfOfficeSettings[exports.OOO_END_DATE]) {
        return false;
    }
    const startDate = outOfOfficeSettings[exports.OOO_START_DATE];
    const endDate = outOfOfficeSettings[exports.OOO_END_DATE];
    return (0, dayjs_1.default)().isBetween((0, dayjs_1.default)(startDate), (0, dayjs_1.default)(endDate));
};
const ApprovalsHeader = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const initialDataActivity = (0, react_router_1.useLoaderData)();
    const { data: currentUser } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const { data: currentTeamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: outOfOfficeSettings } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.getOooSettingsQuery)({
            userId: currentUser?.userId,
            teamId: currentTeamId?.[0] || '',
        }),
        initialData: initialData.outOfOfficeSettings,
    });
    const { data: companyFeatures } = (0, react_query_1.useQuery)({
        ...companyQuery_1.companyFeaturesQuery,
        initialData: initialData.companyFeatures,
    });
    const isOooCompanyActive = companyFeatures?.['ENABLE_OUT_OF_OFFICE_FORWARDING'] === true;
    const isOooEnabled = outOfOfficeSettings
        ? outOfOfficeSettings[exports.OOO_ENABLED] === 'true' || outOfOfficeSettings[exports.OOO_ENABLED] === true
        : false;
    const isOooActive = isOutOutOfOffice(outOfOfficeSettings);
    const forwardedToOoo = outOfOfficeSettings?.[exports.OOO_FORWARD_TO_FULL_NAME];
    const shouldShowOoo = isOooEnabled && isOooActive && forwardedToOoo;
    const getOooNoteMessage = () => {
        const oooEndDate = outOfOfficeSettings[exports.OOO_END_DATE];
        const oooForwardToFullName = outOfOfficeSettings[exports.OOO_FORWARD_TO_FULL_NAME] || 'N/A';
        return `${lexico.tr('You have out of office forwarding to')} ${oooForwardToFullName} ${lexico.tr('scheduled until')} ${oooEndDate ? (0, date_fns_1.format)(new Date(oooEndDate), 'MMMM do, yyyy') : 'N/A'}`;
    };
    const state = (0, useHeaderState_1.useHeaderState)();
    const { uiApprovals, setActiveHeaderTab, setIsOutOfOfficeAsideOpen, headerName, filteredList, viewAllApprovals, setIsDownloadReportAsideOpen, isDownloadReportAsideOpen, } = (0, zustandStore_1.useZustand)(state => ({
        uiApprovals: state.approvals.list,
        filteredList: state.activity.filteredList,
        setIsOutOfOfficeAsideOpen: state.setIsOutOfOfficeAsideOpen,
        setActiveHeaderTab: state.setActiveHeaderTab,
        headerName: state.header.headerName,
        viewAllApprovals: state.activity.viewAllApprovals,
        setIsDownloadReportAsideOpen: state.setIsDownloadReportAsideOpen,
        isDownloadReportAsideOpen: state.aside.downloadReportAside.isOpen,
    }));
    const currentTabHeader = getTabHeader(globalThis.location.pathname);
    const theme = (0, material_1.useTheme)();
    const showAllApprovals = (initialDataActivity &&
        'user' in initialDataActivity &&
        (0, userSelectors_1.isCompanyOrSupportAdmin)(initialDataActivity.user?.roles || [])) ||
        viewAllApprovals;
    const isActivityPage = globalThis.location.pathname.startsWith('/activity');
    const tabs = isActivityPage ? activityTabs : approvalTabs;
    const tabsWithCount = tabs.map(tab => {
        const count = (isActivityPage && showAllApprovals ? filteredList : uiApprovals)[tab.id || '']['count'] || 0;
        return { ...tab, label: `${tab.label} (${count > 49 ? '49+' : count})` };
    });
    (0, react_1.useEffect)(() => {
        if (!currentTabHeader) {
            return;
        }
        setActiveHeaderTab(currentTabHeader);
    }, [currentTabHeader, setActiveHeaderTab, viewAllApprovals]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { className: "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: [(0, jsx_runtime_1.jsxs)(material_1.AppBar, { "ts-variant": "main-header", children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "hamburger-btn", "ts-variant": "hamburger", onClick: () => state.openSideMenuOnMobileView(true), children: (0, jsx_runtime_1.jsx)(Menu_1.default, { style: { stroke: 'black' } }) }), (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: state.headerName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "header-overview-title", "ts-variant": "header", children: headerName }) })] }), (0, jsx_runtime_1.jsx)(headerNavigation_1.default, { tabs: tabsWithCount }), shouldShowOoo && ((0, jsx_runtime_1.jsx)(material_1.Alert, { "data-testid": "ooo-alert", severity: "warning", action: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "ooo-btn", label: lexico.trc('Notification message', 'turn off out of office'), color: uiConstants_1.UI_BUTTON_SECONDARY, size: uiConstants_1.UI_BUTTON_MICRO, style: { float: 'right', fontSize: theme.typography.tsFontSize.small }, onClick: () => {
                                setIsOutOfOfficeAsideOpen(true);
                            } }), children: getOooNoteMessage() }))] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { sx: {
                    p: 2,
                    pb: 0,
                }, size: 6, children: [isActivityPage && showAllApprovals ? ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "download-user-list-button", label: 'Download Report', color: uiConstants_1.UI_BUTTON_SECONDARY, size: uiConstants_1.UI_BUTTON_MICRO, style: { float: 'right', fontSize: theme.typography.tsFontSize.small, backgroundColor: 'white' }, onClick: () => setIsDownloadReportAsideOpen(!isDownloadReportAsideOpen) })) : null, isOooCompanyActive && ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "approval-settings-btn", label: lexico.trc('Button', 'Out of Office'), color: uiConstants_1.UI_BUTTON_SECONDARY, size: uiConstants_1.UI_BUTTON_MICRO, style: { margin: '0 10px', float: 'right', fontSize: theme.typography.tsFontSize.small }, onClick: () => {
                            setIsOutOfOfficeAsideOpen(true);
                        } }))] }), (0, jsx_runtime_1.jsx)(downloadReportAside_1.default, {})] }));
};
exports.default = ApprovalsHeader;
